import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, secondaryValue, secondaryLabel, icon, trend, isNew = false }) => {
  const showSecondary = Number(secondaryValue) > 0;

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-elevation-sm hover:shadow-elevation-md transition-smooth">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-sm md:text-base font-medium text-muted-foreground">{title}</h3>
          </div>
          <div className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-1">
            {value}
            {showSecondary && (
              <>
                <span className="font-normal text-muted-foreground">
                  {' '}+ {secondaryValue}
                </span>
                {secondaryLabel && (
                  <span className="text-sm md:text-base font-medium text-muted-foreground ml-1">
                    {secondaryLabel}
                  </span>
                )}
              </>
            )}
          </div>
          {trend && (
            <div className="flex items-center gap-1 text-xs md:text-sm text-success">
            </div>
          )}
        </div>
        <div className="flex items-center justify-center w-10 md:w-12 mt-1 bg-primary/10 rounded-lg">
          <Icon name={icon} size={20} color="var(--color-primary)" />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;